'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCartOutline = function IoIosCartOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 31.3c1 0 1.9 0.8 1.9 1.8s-0.9 1.9-1.9 1.9-1.9-0.9-1.9-1.9 0.9-1.8 1.9-1.8z m0 2.5c0.3 0 0.6-0.4 0.6-0.7s-0.3-0.6-0.6-0.6-0.6 0.3-0.6 0.6 0.3 0.7 0.6 0.7z m17.5-2.5c1 0 1.9 0.8 1.9 1.8s-0.9 1.9-1.9 1.9-1.9-0.9-1.9-1.9 0.9-1.8 1.9-1.8z m0 2.5c0.3 0 0.6-0.4 0.6-0.7s-0.3-0.6-0.6-0.6-0.6 0.3-0.6 0.6 0.3 0.7 0.6 0.7z m5-23.8l-1.2 10-21.2 3.8 0.4 2.3c0.5 2.7 1.6 2.7 2 2.7h18.8v1.2h-18.8c-0.9 0-1.6-0.4-2.2-1.1-0.5-0.6-0.8-1.5-1-2.6l-3.4-18.3c-0.1-0.6-0.2-0.9-0.5-1.2-0.5-0.4-1.4-0.5-2.9-0.5v-1.3c1.8 0 3 0.3 3.7 0.9 0.5 0.4 0.8 1.1 0.9 1.6z m-2.3 8.9l0.9-7.7-23.8-2.4 2.5 13.7z' })
        )
    );
};

exports.default = IoIosCartOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-cart-outline.js
// module id = 2132
// module chunks = 0